/**
 * The state variations for the WizardStep component
 * @public
 */
export const WizardStepStates = {
    incomplete: "incomplete",
    complete: "complete",
    error: "error"
};
export const WizardStepEvents = {
    stepChange: "step-change",
    stepSelect: "step-select"
};
//# sourceMappingURL=wizard-step.options.js.map